<template>
    <div>
        <h3>記事の公開について</h3>
        <div>
            <p>
                記事を公開するのは簡単です。
            </p>
            <p>
                編集した記事の「公開」ボタンをクリックしてください。
                その記事は指定された公開場所に公開されます。
            </p>

            <h4>公開場所について</h4>
            <img src="/img/help/article/03.png" alt="ジャンル公開" class="img-thumbnail mb-3">
            <p>
                ジャンルを公開先に選んだ場合、そのジャンル欄の小説リストの下に記事一覧が表示されます。
                最大６件ずつ表示されます。
            </p>
            <p>
                小説作品を公開先に選んだ場合、その小説の目次ページ及びサイドバー下部に記事へのリンクが表示されます。
                小説作品のレーティングと記事のレーティングは無関係です。
                R18作品にR15記事を表示することも可能です。
            </p>
            <p>
                シリーズを公開先に選んだ場合、シリーズページの左側に記事へのリンクが表示されます。
            </p>

            <h4>表示の順番について</h4>
            <p>
                記事は公開日時に対して<b>新しい順</b>で表示されます。
                つまり、「公開」あるいは「更新」を行った記事が最上位に表示されます。
            </p>
            <p>
                公開済みの記事の公開日時を変更したくない場合、
                「更新」ボタンをクリックした後に表示される「記事の反映」を選択してください。
                これを選択すると、公開日時を更新しません。
                記事の順番も変わりません。
            </p>

            <h4>アウトライン</h4>
            <img src="/img/help/article/04.png" alt="アウトライン" class="img-thumbnail mb-3">
            <p>
                見出しを設定すると、自動的にアウトラインを表示します。
                これはPCのみに表示されます。
            </p>
            <p>
                アウトラインは見出しのレベルによって自動的にインデントされ、
                記事の構造を把握しやすいものにします。
                アウトラインをクリックすると、見出しに自動スクロールします。
            </p>

            <h4>関連記事について</h4>
            <p>
                記事の最後に「関連記事」が最大３つ表示されます。
            </p>
            <p>
                この関連記事は、いま閲覧している記事と同じジャンル、同じシリーズ、同じ小説に公開されているか、
                同一のタグを持つものがランダムに選ばれます。
            </p>
            <p>
                公開先が異なる場合でも、同一のタグを使うことで、関連記事として結びつけることができます。
            </p>

        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "記事を公開する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>